import { Injectable } from '@angular/core';
import { IRate } from '@core/models/Rate/Rate.interface';
import { Observable, of } from 'rxjs';
import { AmTripsUpdateService, ProductType } from '@am/trips-update-service';
import { Store } from '@ngrx/store';
import { AppState } from '@store/app.reducer';
import { selectSearchParams } from '@store/app-context/app-context.selectors';
import { switchMap, take } from 'rxjs/operators';
import { SearchValues } from '@store/app-context/app-context.reducer';
import { ReqService } from '@core/services/req.service';

@Injectable({
  providedIn: 'root',
})
export class ExpertsTripWrapperService {
  constructor(
    private tripsUpdateService: AmTripsUpdateService,
    private contextService: ReqService,
    private store: Store<AppState>,
  ) {}

  public addToTrip(rate: IRate): Observable<any> {
    return this.store.select(selectSearchParams).pipe(
      take(1),
      switchMap((searchParams) => {
        if (this.contextService.isExperts()) {
          return this.tripsUpdateService.addProductInTripToCheckout(
            ProductType.HOTEL,
            this.getTripFavoriteData(
              searchParams,
              this.contextService.getHotelStaticInfo(),
            ),
            rate.id,
            rate.price.currency.code,
          );
        }
        return of(false);
      }),
    );
  }

  private getTripFavoriteData(
    searchValues: SearchValues,
    hotelStaticInfo: any,
  ): {
    id: string;
    checkin_time: string;
    checkout_time: string;
    checkin: string;
    checkout: string;
    room: string;
  } {
    return {
      id: hotelStaticInfo.id,
      checkin_time: hotelStaticInfo.checkin_time,
      checkout_time: hotelStaticInfo.checkout_time,
      room: searchValues.rooms,
      checkin: searchValues.checkIn,
      checkout: searchValues.checkOut,
    };
  }
}
